export default __webpack_public_path__ + "static/media/convert70L.ce2dc218.jpg";